import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Carica il KnowledgePack filtrato per ruolo dal backend Foundation.
 *
 * @param {string} appKey - chiave del pack (es. "presenze")
 * @param {object} options - { role?, topic? }
 * @returns {{ pack, loading, error, reload }}
 */
export function useGuidePack(appKey, { role, topic } = {}) {
  const [pack, setPack] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const params = { app: appKey };
    if (role) params.role = role;
    if (topic) params.topic = topic;
    api
      .get("/guide/pack", { params })
      .then(({ data }) => {
        if (cancelled) return;
        setPack(data);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [appKey, role, topic, reloadKey]);

  const reload = () => setReloadKey((k) => k + 1);
  return { pack, loading, error, reload };
}
